[
    "abulón",
    "acetato",
    "glicérido de manteca hidrogenada acetilada",
    "lanolina acetilada",
    "alcohol de lanolina acetilado",
    "ricinoleato de lanolina acetilado",
    "sebo acetilado",
    "leche acidófila",
    "adrenalina",
    "glándulas suprarrenales de ganado",
    "glándulas suprarrenales de cerdos",
    "glándulas suprarrenales de ovejas",
    "placenta",
    "alanina",
    "alcloxa",
    "alcohol alifático",
    "caimán",
    "piel de caimán",
    "ácidos alfa-hidroxi",
    "ámbar gris",
    "amerachol",
    "amerchol l101",
    "ácido aminiuccinato",
    "caseinato de amonio",
    "líquido amniótico",
    "proteína animal hidrolizada isotérica ampd",
    "amilasa",
    "anchoas",
    "anchoa",
    "angora",
    "huesos de animales",
    "aminoácidos de colágeno animal",
    "grasa animal",
    "grasas animales",
    "grasas y aceites animales",
    "pelo de animal",
    "aminoácidos de queratina animal",
    "aceite animal",
    "aceites animales",
    "placenta animal",
    "derivado de proteína animal",
    "extracto de tejido animal",
    "ácido araquidónico",
    "propionato de araquidilo",
    "astracán",
    "tocino de lomo",
    "grasa dorsal",
    "tocino",
    "lubina",
    "alcohol batílico",
    "isoestearato batílico",
    "oso",
    "polen de abeja",
    "productos de abeja",
    "carne de res",
    "corazón de res",
    "hígado de res",
    "lengua de res",
    "polen de abeja",
    "cera de abeja",
    "panal de cera de abeja",
    "tocino de panceta",
    "proteína animal hidrolizada benzyltrimonium",
    "bisonte",
    "sangre",
    "fraccionamiento de plasma sanguíneo",
    "lengua de sangre",
    "cerdas de jabalí",
    "jamón hervido",
    "ceniza de hueso",
    "carbón de hueso",
    "carbón de hueso/negro de hueso",
    "carbón vegetal de hueso",
    "tierra de hueso",
    "harina de hueso",
    "fosfato de hueso",
    "sopa de hueso",
    "hueso/harina de hueso",
    "negro de hueso",
    "harina de hueso",
    "bonito",
    "albúmina de suero bovino",
    "extracto de cerebro",
    "bratwurst",
    "queso de cabeza",
    "tocino de desayuno",
    "bresaola",
    "bruehwurst",
    "bruhwurst",
    "búfalo",
    "leche de búfala",
    "carne de caza",
    "mantequilla",
    "grasa de mantequilla",
    "sólidos de mantequilla",
    "suero de leche",
    "polvo de suero de leche",
    "aceite piscino c30-46",
    "calamares",
    "calciferol",
    "calciferool",
    "caseinato de calcio",
    "hígado de ternera",
    "piel de ternera",
    "extracto de piel de ternera",
    "leche de camella",
    "tocino canadiense",
    "cantaridina",
    "tintura de cantáridas",
    "capiz",
    "triglicérido caprílico",
    "carbamida",
    "caribú",
    "carmín",
    "carmín cochinilla ácido carmínico",
    "carmín/ácido carmínico",
    "carmínico",
    "ácido carmínico",
    "caroteno",
    "caroteno provitamina a beta caroteno",
    "carpa",
    "caseína",
    "caseína caseinato",
    "caseinato",
    "caseinógeno",
    "cachemira",
    "castor",
    "castor castóreo",
    "castóreo",
    "bagre",
    "catgut",
    "cataridina",
    "caviar",
    "caviar(e)",
    "caviar",
    "cera flava",
    "cerebrósidos",
    "ceteth",
    "ceteth-02",
    "ceteth-1",
    "ceteth-10",
    "ceteth-2",
    "ceteth-30",
    "ceteth-4",
    "ceteth-6",
    "lactato de cetilo",
    "miristato de cetilo",
    "gamuza",
    "queso",
    "pollo",
    "pechuga de pollo",
    "hígado de pollo",
    "pan de pollo",
    "jamón picado",
    "quitosano",
    "colesterina",
    "colesterol",
    "bitartrato de colina",
    "condroitina",
    "jamón picado",
    "chorizo",
    "quimotripsina",
    "mantequilla clarificada",
    "crema coagulada",
    "cochinilla",
    "bacalao",
    "aceite de hígado de bacalao",
    "fiambres",
    "coleth-24",
    "colágeno",
    "hidrolizado de colágeno",
    "leche condensada",
    "glaseado de confitería",
    "jamón cocido",
    "carnes cocidas",
    "coral",
    "carne en conserva",
    "gallina de Cornualles",
    "corticoesteroide",
    "corticoesteroide",
    "cortisona corticoesteroide",
    "cotechino",
    "requesón",
    "cangrejo",
    "carne de cangrejo",
    "cangrejo de río",
    "cangrejo de río",
    "crema",
    "mariscos crustáceos",
    "cuajada",
    "natilla",
    "cisteína, forma l",
    "cistina",
    "carne oscura",
    "dashi",
    "fosfato dea-oleth-10",
    "ciervo",
    "carne de venado",
    "suero deslactosado",
    "carnes de delicatessen",
    "suero desmineralizado",
    "ácido desoxirribonucleico",
    "colágeno animal desamidado",
    "colágeno desamidado",
    "desamidocolágeno",
    "devon",
    "cistina dicapriloílo",
    "tricaseinamida de dietileno",
    "dihidrocolesterol",
    "octildecanoato de dihidrocolesterol",
    "dihidrocoleth-15",
    "dihidrocoleth-30",
    "cloruro de bencilmonio de sebo dihidrogenado",
    "metilamina de sebo dihidrogenado",
    "ftalato de sebo dihidrogenado",
    "óxido de amina de sebo dihidroxietilo",
    "hidrogentalloamina dimetílica",
    "esteariamina dimetílica",
    "talloamina dimetílica",
    "glutamato de sebo hidrogenado disódico",
    "glutamato de sebo hidrogenado disódico",
    "disulfosuccinato de tallamido mea disódico",
    "dipropionato de tallowamino disódico",
    "cloruro de ditallodimonium",
    "adn",
    "plumón",
    "suero de leche seco",
    "yema de huevo seca",
    "sólidos de leche seca",
    "leche entera seca",
    "pato",
    "tocino de pato",
    "hígado de pato",
    "sustancias del duodeno",
    "pan holandés",
    "colorantes",
    "e120",
    "e441",
    "e542",
    "e904",
    "e913",
    "fosfato óseo comestible",
    "huevo",
    "albúmina de huevo",
    "albúmina/albumina de huevo",
    "albúmina de huevo",
    "aceite de huevo",
    "polvo de huevo",
    "proteína de huevo",
    "claras de huevo",
    "yema de huevo",
    "extracto de yema de huevo",
    "yemas de huevo",
    "huevos",
    "edredón",
    "elastina",
    "tocino de alce",
    "extracto de embrión",
    "emú",
    "aceite de emú",
    "aceite epiderm r",
    "ergisterol",
    "ergosterol",
    "benzoato de estradiol",
    "estrógeno",
    "estrógeno estradiol",
    "estrógeno/estradiol",
    "estrona",
    "araquidonato de etilo",
    "éster etílico de proteína animal hidrolizada",
    "lipineato de etilo",
    "lipineato de etil morrhuate",
    "etil morrhuatelipineato",
    "etileareaquidonato",
    "amida de sebo deshidrogenado de etileno",
    "leche evaporada",
    "leche de oveja",
    "leche desnatada",
    "yogur desnatado",
    "ácidos grasos",
    "plumas",
    "leche de camella fermentada",
    "crema fermentada",
    "leche fermentada",
    "pescado",
    "glicéridos de pescado",
    "hígado de pescado",
    "aceite de hígado de pescado",
    "hígados de pescado",
    "aceite de pescado",
    "salsa de pescado",
    "escamas de pescado",
    "salsa de pescado",
    "aceite de fletán",
    "piel",
    "gel",
    "gelatina",
    "gel de gelatina",
    "gelatina(e)",
    "gelatina",
    "gelbwurst",
    "ghee",
    "mollejas",
    "glucosa tirosinasa",
    "ácido glucurónico",
    "glicéridos",
    "glicerina glicerol",
    "glicerina",
    "lanolato de glicerilo",
    "glicerilos",
    "glicol",
    "glycreth-26",
    "cabra",
    "queso de cabra",
    "leche de cabra",
    "ganso",
    "plumas aislantes de ganso",
    "hígado de ganso",
    "carne molida",
    "urogallo",
    "guanina",
    "esencia de perla de guanina",
    "guanina/esencia de perla",
    "gallina de Guinea",
    "tocino gitano",
    "eglefino",
    "pelo de cerdos",
    "halibut",
    "jamón",
    "pan de jamón y queso",
    "queso de cabeza",
    "crema espesa",
    "heptilundecanol",
    "cuero",
    "pegamento de cuero",
    "leche homogeneizada",
    "miel",
    "panal",
    "caballo",
    "pelo de caballo",
    "carne de caballo",
    "crin de caballo",
    "pelo de cerdo",
    "perro caliente",
    "proteína placentaria humana",
    "extracto umbilical humano",
    "ácido hialurónico",
    "proteína placentaria humana hidrolizada",
    "glicérido animal hidrogenado",
    "amina de ditallow hidrogenada",
    "ditallamina hidrogenada",
    "miel hidrogenada",
    "laneth-20 hidrogenado",
    "laneth-25 hidrogenado",
    "laneth-5 hidrogenado",
    "lanolina hidrogenada",
    "alcohol de lanolina hidrogenado",
    "glicérido de manteca hidrogenado",
    "aceite de hígado de tiburón hidrogenado",
    "ácido de sebo hidrogenado",
    "betaína de sebo hidrogenado",
    "glicérido de sebo hidrogenado",
    "elastina animal hidrolizada",
    "queratina animal hidrolizada",
    "proteína animal hidrolizada",
    "caseína hidrolizada",
    "elastina hidrolizada",
    "proteína placentaria humana hidrolizada",
    "queratina hidrolizada",
    "proteína de leche hidrolizada",
    "seda hidrolizada",
    "lanolina hidroxilada",
    "helado",
    "urea imidazolidinil",
    "caseinato de hierro",
    "cola de pescado",
    "lanolina isobutilada",
    "lanolato de isopropilo",
    "isopropil tallowatelisopropil lanolato",
    "palmitato de isopropilo",
    "palmitato de isopropilo",
    "proteína animal hidrolizada isoesteárica",
    "proteína animal hidrolizada isoestearoílo",
    "jagdwurst",
    "papada",
    "canguro",
    "katsuobushi",
    "katsuobushi (okaka)",
    "queratina",
    "aminoácidos de queratina",
    "l-cisteína",
    "clorhidrato de l-cisteína",
    "forma l",
    "leche reducida en lactosa",
    "lactalbúmina",
    "ácido láctico del suero",
    "levaduras lácticas",
    "ácido láctico",
    "lactoferrina",
    "lactoglobulina",
    "lactosa",
    "leche sin lactosa",
    "lactulosa",
    "cordero",
    "tocino de cordero",
    "laneth",
    "laneth-10",
    "laneth-11",
    "laneth-12",
    "laneth-13",
    "laneth-14",
    "laneth-15",
    "laneth-16",
    "laneth-17",
    "laneth-18",
    "laneth-19",
    "laneth-20",
    "laneth-21",
    "laneth-22",
    "laneth-23",
    "laneth-24",
    "laneth-25",
    "laneth-26",
    "laneth-27",
    "laneth-28",
    "laneth-29",
    "laneth-30",
    "laneth-31",
    "laneth-32",
    "laneth-33",
    "laneth-34",
    "laneth-35",
    "laneth-36",
    "laneth-37",
    "laneth-38",
    "laneth-39",
    "laneth-40",
    "laneth-5",
    "laneth-6",
    "laneth-7",
    "laneth-8",
    "laneth-9",
    "acetato de laneth-9",
    "acetato de laneth10",
    "lanógeno",
    "lanoínamida dea",
    "lanolina",
    "ácido de lanolina",
    "ácidos de lanolina",
    "alcohol de lanolina",
    "alcoholes de lanolina",
    "linoleato de lanolina",
    "aceite de lanolina",
    "ricinoleato de lanolina",
    "cera de lanolina",
    "lanolina(e)",
    "lanolina",
    "lanolina: ácido de lanolina",
    "lanoínamida dea",
    "lanosterol",
    "lanosteroles",
    "manteca",
    "glicérido de manteca",
    "proteína animal hidrolizada lauroílo",
    "cuero",
    "lecitina bitartrato de colina",
    "lecitina bitartrato de colina",
    "lipasa",
    "hígado",
    "extracto de hígado",
    "paté de hígado",
    "langosta",
    "leche baja en grasa",
    "yogur bajo en grasa",
    "esponja luna",
    "esponja luna",
    "pan de almuerzo",
    "carnes de almuerzo",
    "carnes de almuerzo",
    "caballa",
    "caseinato de magnesio",
    "lanolato de magnesio",
    "tallowato de magnesio",
    "leche malteada",
    "extracto mamario",
    "aceite marino",
    "sopa de médula",
    "mayonesa",
    "proteína animal hidrolizada mea",
    "carne",
    "pan de carne",
    "albóndiga",
    "pollo separado mecánicamente",
    "aceite de menhaden",
    "metionina",
    "mettwurst",
    "leche",
    "chocolate con leche",
    "derivado de leche",
    "leche de mamíferos",
    "leche en polvo",
    "proteína de leche",
    "piel de leche",
    "azúcar de leche",
    "grasa láctea",
    "leche en polvo",
    "carne picada",
    "carne picada",
    "aceite de visón",
    "dilamina minkamoropropil",
    "mohair",
    "mariscos moluscos",
    "rape",
    "alce",
    "mortadela",
    "aceite de mossbunker",
    "mucopolisacáridos",
    "salmonete",
    "extracto muscular",
    "almizcle ambrette",
    "mejillón",
    "mejillones",
    "cordero",
    "ácido mirístico",
    "proteína animal hidrolizada miristoílo",
    "miristilo",
    "miristilos",
    "sabor natural de mantequilla",
    "rojo natural 4",
    "cuello",
    "leche desnatada",
    "turrón",
    "ocenol",
    "pulpo",
    "okaka",
    "dimetilamina hidrolizada oleamidopropil proteína animal",
    "oleostearina",
    "oleostearina",
    "proteína animal hidrolizada oleoílo",
    "oleths",
    "araquidato de oleílo",
    "betaína oleílo",
    "imidazolina oleílo",
    "lanolato de oleílo",
    "oleato de oleílo",
    "estearato de oleílo",
    "alcohol oleílico ocenol",
    "oleílimidazolina",
    "ácidos grasos omega-3",
    "zarigüeya",
    "carne de órganos",
    "carnes de órganos",
    "órganos",
    "avestruz",
    "ovalbúmina",
    "extracto ovárico",
    "bilis de buey",
    "hiel de buey",
    "hiel de buey",
    "ostra",
    "ostras",
    "proteína de leche hidrolizada palmitoílo",
    "proteína animal hidrolizada palmitoílo",
    "panceta",
    "paracaseína",
    "perdiz",
    "leche pasteurizada",
    "perla",
    "esencia de perla",
    "amida de sebo hidrogenado peg-13",
    "poliamina de sebo peg-15",
    "sólidos de leche peg-2",
    "tallowato peg-20",
    "tallowato de glicerilo peg-28",
    "aceite y cera de lanolina peg-75",
    "glicéridos de pescado hidrogenados peg-8",
    "pentahidroescualeno",
    "pepsina",
    "perhidroescualeno",
    "glaseado farmacéutico",
    "faisán",
    "hombro de picnic",
    "extracto de piel de cerdo",
    "placenta",
    "polipéptidos proteína placentaria",
    "enzimas placentarias",
    "extracto placentario",
    "proteína placentaria",
    "platija",
    "aceite de pogy",
    "abadejo",
    "poltetileno",
    "éter cetílico de poltetileno",
    "poliglicerol",
    "éter de alcohol de lanolina poliglicerilo-2",
    "polipéptidos proteína",
    "páncreas porcino",
    "cerdo",
    "grasa de cerdo",
    "rollo de cerdo",
    "caseinato de potasio",
    "tallowato de potasio",
    "proteína animal hidrolizada undecilenoílo de potasio",
    "aves de corral",
    "lanolina ppg-12-peg-50",
    "éter metílico ppg-2",
    "ppg-5-ceteth-20",
    "ppg-10",
    "éter de glucosa metílica ppg-20",
    "éter cetílico ppg-30",
    "éter de lanolina ppg-30",
    "gamba",
    "acetato de pregnenolona",
    "pristano",
    "propóleo",
    "prosciutto",
    "provitamina a",
    "aceite purcelline syn",
    "codorniz",
    "quaternium 27",
    "conejo",
    "carne roja",
    "leche reducida en grasa",
    "yogur reducido en grasa",
    "caseína de cuajo",
    "glaseado resinoso",
    "reticulina",
    "retinol",
    "carne asada",
    "cerdo asado",
    "huevas",
    "jalea real",
    "marta",
    "pinceles de marta",
    "isomerato de sacárido",
    "salami",
    "salceson",
    "salmón",
    "sardina",
    "salchicha",
    "salchichas",
    "vieira",
    "vieiras",
    "esponja de mar",
    "aceite de tortuga marina",
    "esponja marina",
    "albúmina sérica",
    "proteínas séricas",
    "aceite de hígado de tiburón",
    "aceite de hígado de tiburón",
    "leche de oveja",
    "piel de oveja",
    "piel de oveja",
    "goma laca",
    "glaseado resinoso de goma laca",
    "cera de goma laca",
    "hombro",
    "camarón",
    "shrimph",
    "tocino lateral",
    "seda",
    "aminoácidos de seda",
    "polvo de seda",
    "polvo de seda",
    "leche desnatada",
    "piel",
    "tocino de losa",
    "carnes en rodajas",
    "jamón ahumado",
    "caracol",
    "caracoles",
    "serpiente",
    "pargo",
    "sodio / tea-lauroílo proteína animal hidrolizada",
    "sodio / tea-undecilenoílo proteína animal hidrolizada",
    "caseinato de sodio",
    "sodio coco-proteína animal hidrolizada",
    "sodio soja proteína animal hidrolizada",
    "sulfato de sebo sódico",
    "tallowato de sodio",
    "undecilenoato de sodio",
    "lactilato de sodio steroílo",
    "lactilato de sodio steroílo",
    "colágeno soluble",
    "crema agria",
    "leche agria",
    "sólidos de leche agria",
    "leche agria",
    "imidazolina de soja hidroxietilo",
    "aceite de esperma",
    "intestinos de cachalote",
    "espermaceti",
    "palmitato de cetilo espermacético aceite de esperma",
    "extracto de bazo",
    "esponja (luna y mar)",
    "pichón",
    "calamar",
    "ardilla",
    "bistec",
    "amina esterildimetílica",
    "esteroides esteroles",
    "esteroles",
    "bistec para guisar",
    "stilton",
    "tocino graso",
    "suero dulce lácteo",
    "suero dulce",
    "mollejas",
    "leche condensada azucarada",
    "pez espada",
    "sebo",
    "ácido de sebo",
    "amida de sebo",
    "amina de sebo",
    "óxido de amina de sebo",
    "aminopropilamina de sebo",
    "alcohol graso de sebo",
    "glicéridos de sebo",
    "imidazolina de sebo hidroxietilo",
    "imidazolina de sebo",
    "cloruro de trimonium de sebo - sebo",
    "óxido de tallowamidopropilamina",
    "talloweth-6",
    "tallowmida dea",
    "tallowmida dea y mea",
    "tallowmida mea",
    "hidroxisultaína tallowmidopropilo",
    "tallowminopropilamina",
    "tallowmphoacete",
    "tea-abietoílo hidrolizadaproteína animal",
    "tea-coco proteína animal hidrolizada",
    "tea-lauroílo aminoácidos de colágeno animal",
    "tea-lauroílo aminoácidos de queratina animal",
    "tea-miristol proteína animal hidrolizada",
    "tea-undecilenoílo proteína animal hidrolizada",
    "extracto testicular",
    "salchicha de Turingia",
    "tilapia",
    "lengua",
    "etosulfato de proteína animal hidrolizada triethonium",
    "trilaneth-4fosfato",
    "callos",
    "alcoholes triterpenos",
    "trucha",
    "tripsina",
    "atún",
    "pavo",
    "tocino de pavo",
    "pechuga de pavo",
    "tortuga",
    "aceite de tortuga",
    "aceite de tortuga marina",
    "tirosina",
    "leche no homogeneizada",
    "urea",
    "urea carbamida",
    "ácido úrico",
    "ácido úrico de vacas",
    "ácido úrico",
    "orina",
    "ternera",
    "pan de ternera",
    "venado",
    "vitamina d ergocalciferol vitamina d",
    "vitamina h",
    "vitaminab",
    "factor vitaminab",
    "volaise",
    "suero",
    "polvo de suero",
    "proteína de suero",
    "crema batida",
    "cobertura batida",
    "carne blanca",
    "leche entera",
    "yogur de leche entera",
    "jabalí",
    "carne silvestre",
    "lana",
    "grasa de lana",
    "cera de lana",
    "alcoholes de cera de lana",
    "yogur",
    "yogur",
    "caseinato de zinc",
    "proteína animal hidrolizada de zinc"
]